import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 'test';

const slice = createSlice({
  name: '$paymentEnvirontment',
  initialState,
  reducers: {
    setPaymentEnvironment(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setPaymentEnvironment } = slice.actions;
export default slice.reducer;
